/* L'OREMONT PARIS — PDP Conversion-Layer
   1) Rating-Zeile + rotierendes Testimonial: liest die Bewertungs-Section
      (#pdp-reviews, data-count/data-avg) — EINE Datenquelle, nichts erfunden.
   2) Bundle-Boxen: Einzeln = nativer Formular-Submit (Gravur-Logik aus
      gravur.js bleibt unangetastet), Duo/Ensemble = /cart/add.js mit den
      echten Varianten-IDs aus data-items.
   3) Sticky-Add-to-Cart: erscheint, wenn der Haupt-CTA aus dem Viewport ist.
*/
(function () {
  'use strict';
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1) Rating-Zeile + Testimonial-Rotation ---------- */
  (function rating() {
    var reviews = document.getElementById('pdp-reviews');
    var summary = document.getElementById('pdp-rating');
    if (!reviews || !summary) return;
    var count = parseInt(reviews.dataset.count || '0', 10);
    if (!count) return;

    var avg = parseFloat(reviews.dataset.avg || '0');
    var starsEl = summary.querySelector('.pdp-rating-stars');
    var countEl = summary.querySelector('.pdp-rating-count');
    if (starsEl) {
      var filled = Math.round(avg);
      var html = '';
      for (var i = 1; i <= 5; i++) html += '<span class="pdp-star' + (i <= filled ? ' is-filled' : '') + '">★</span>';
      starsEl.innerHTML = html;
      starsEl.setAttribute('role', 'img');
      starsEl.setAttribute('aria-label', (reviews.dataset.avgDisplay || avg) + ' von 5 Sternen');
    }
    if (countEl) countEl.textContent = count === 1 ? '1 Bewertung' : count + ' Bewertungen';
    summary.hidden = false;

    /* Social-Proof-Karte einblenden; „Verifizierter Kauf“-Label nur, wenn die
       Bewertungs-Section wirklich verifizierte Käufe enthält (eine Datenquelle). */
    var proofCard = document.getElementById('pdp-proof');
    if (proofCard) proofCard.hidden = false;
    var verifiedLabel = document.getElementById('pdp-proof-verified');
    if (verifiedLabel && reviews.querySelector('.pdp-review-verified')) verifiedLabel.hidden = false;

    /* Rotierendes Testimonial aus den echten Review-Texten */
    var cards = reviews.querySelectorAll('[data-review-quote]');
    var quotes = [];
    cards.forEach(function (c) {
      var t = (c.dataset.reviewQuote || '').trim();
      if (!t) return;
      if (t.length > 140) t = t.slice(0, 140).replace(/\s\S*$/, '') + ' …';
      quotes.push({ text: t, author: c.dataset.reviewAuthor || '' });
    });
    if (!quotes.length) return;

    var box = document.getElementById('pdp-testimonial');
    if (!box) return;
    var p = box.querySelector('p');
    var cite = box.querySelector('cite');
    var idx = 0;
    function show(i) {
      p.textContent = '„' + quotes[i].text + '“';
      cite.textContent = quotes[i].author ? '— ' + quotes[i].author : '';
    }
    show(0);
    box.hidden = false;
    if (quotes.length > 1 && !prefersReduced) {
      setInterval(function () {
        box.classList.add('is-fading');
        setTimeout(function () {
          idx = (idx + 1) % quotes.length;
          show(idx);
          box.classList.remove('is-fading');
        }, 480);
      }, 6000);
    }
  })();

  /* ---------- 2) Bundle-Boxen ---------- */
  var form = document.getElementById('pdp-form');
  var addBtn = document.getElementById('pdp-add');
  var addPrice = document.getElementById('pdp-add-price');
  var priceEl = document.getElementById('pdp-price');
  var priceNote = document.getElementById('pdp-price-note');
  var stickyPrice = document.getElementById('pdp-sticky-price');
  var bundleError = document.getElementById('pdp-bundle-error');
  var radios = document.querySelectorAll('#pdp-bundle-select input[name="bundle"]');

  function currentBundle() {
    var sel = null;
    radios.forEach(function (r) { if (r.checked) sel = r; });
    return sel;
  }

  function gravurPrice() {
    /* Aktuellen Einzeln-Preis aus dem Gravur-Modul lesen (Toggle-Zustand zählt) */
    var root = document.querySelector('[data-gravur]');
    if (root && root.dataset.gravurPriceMono) {
      var toggle = root.querySelector('#gravur-toggle');
      return toggle && toggle.checked ? root.dataset.gravurPriceMono : root.dataset.gravurPriceBase;
    }
    return null;
  }

  function setPrices(text) {
    if (!text) return;
    if (addPrice) addPrice.textContent = text;
    if (stickyPrice) stickyPrice.textContent = text;
    if (priceEl) priceEl.textContent = text;
  }

  function applyBundle() {
    var sel = currentBundle();
    if (!sel) return;
    var single = sel.value === 'single';
    var gravurRoot = document.querySelector('[data-gravur]');

    if (gravurRoot) {
      /* Gravur bleibt bei ALLEN Optionen wählbar — bei Sets ohne Aufpreis. */
      gravurRoot.hidden = false;
      var toggle = gravurRoot.querySelector('#gravur-toggle');
      if (toggle && toggle.disabled) {
        toggle.disabled = false;
        toggle.dispatchEvent(new Event('change'));
      }
    }

    if (single) {
      var gp = gravurPrice();
      if (gp) { setPrices(gp); }
      else if (sel.dataset.price) { setPrices(sel.dataset.price); }
      if (priceNote && !gravurRoot) priceNote.textContent = 'inkl. MwSt.';
    } else {
      setPrices(sel.dataset.price);
      if (priceNote) priceNote.textContent = sel.dataset.self === '1' ? 'inkl. MwSt. · beide zusammen' : 'inkl. MwSt. · Set-Preis';
    }
    if (bundleError) bundleError.hidden = true;
  }

  if (radios.length) {
    radios.forEach(function (r) { r.addEventListener('change', applyBundle); });
    applyBundle();
  }

  /* Preise mit dem Gravur-Modul synchron halten. gravur.js initialisiert NACH
     diesem Script und schreibt beim Start Preis/Note — ist Duo/Ensemble gewählt,
     setzen wir hier den Set-Preis wieder durch (Set-Preis hat Vorrang). */
  document.addEventListener('gravur:change', function (e) {
    var sel = currentBundle();
    if (sel && sel.value !== 'single') {
      var root = document.querySelector('[data-gravur]');
      if (root) {
        root.hidden = true;
        /* gravur.js hat seine Felder gerade re-aktiviert — wieder aus, sonst
           blockiert das versteckte required-Feld die Formular-Validierung */
        root.querySelectorAll('input').forEach(function (el) { el.disabled = true; });
      }
      setPrices(sel.dataset.price);
      if (priceNote) priceNote.textContent = sel.dataset.self === '1' ? 'inkl. MwSt. · beide zusammen' : 'inkl. MwSt. · Set-Preis';
      return;
    }
    if (e.detail && e.detail.price && stickyPrice) stickyPrice.textContent = e.detail.price;
  });

  /* Submit-Weiche: Duo/Ensemble laufen über /cart/add.js (mehrere echte Produkte) */
  function addBundleToCart(sel) {
    var ids;
    try { ids = JSON.parse(sel.dataset.items || '[]'); } catch (err) { ids = []; }
    /* Paar-Optionen (data-self="1"): die AKTUELL gewählte Variante des Produkts
       (Farb-Swatch/Select zählt) kommt zusätzlich zu den data-items in den Cart. */
    if (sel.dataset.self === '1' && form) {
      var idField = form.querySelector('input[name="id"]:checked') ||
                    form.querySelector('select[name="id"]') ||
                    form.querySelector('input[name="id"][type="hidden"]:not([disabled])');
      var selfId = idField && idField.value ? parseInt(idField.value, 10) : NaN;
      if (!isNaN(selfId)) ids.unshift(selfId);
    }
    if (!ids.length) return;
    /* Gravur-Angaben (falls aktiv) ans erste Set-Item haengen */
    var props = null;
    var gRoot = document.querySelector('[data-gravur]');
    var gToggle = gRoot && gRoot.querySelector('#gravur-toggle');
    if (gRoot && gToggle && gToggle.checked) {
      props = {};
      gRoot.querySelectorAll('input[name^="properties["], select[name^="properties["]').forEach(function (el) {
        if (el.disabled) return;
        if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
        var key = el.name.slice(11, -1);
        if (el.value) props[key] = el.value;
      });
      if (!Object.keys(props).length) props = null;
    }
    if (addBtn) addBtn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id, i) {
        var item = { id: id, quantity: 1 };
        if (i === 0 && props) item.properties = props;
        return item;
      }) })
    }).then(function (res) {
      if (!res.ok) throw new Error('cart/add ' + res.status);
      window.location.href = '/cart';
    }).catch(function () {
      if (addBtn) addBtn.disabled = false;
      if (bundleError) bundleError.hidden = false;
    });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      var sel = currentBundle();
      if (!sel || sel.value === 'single') return; /* nativer Weg inkl. Gravur-Guard */
      e.preventDefault();
      e.stopImmediatePropagation();
      addBundleToCart(sel);
    });
  }

  /* ---------- 3) Sticky-Add-to-Cart ---------- */
  (function sticky() {
    var bar = document.getElementById('pdp-sticky');
    var cta = document.querySelector('.pdp-cta');
    if (!bar || !cta || !form) return;
    var btn = document.getElementById('pdp-sticky-add');

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', String(!show));
        });
      }, { threshold: 0 });
      io.observe(cta);
    }

    if (btn) {
      btn.addEventListener('click', function () {
        var sel = currentBundle();
        if (sel && sel.value !== 'single') { addBundleToCart(sel); return; }
        /* Einzeln: echter Formular-Submit — Gravur-Validierung greift */
        if (typeof form.requestSubmit === 'function' && addBtn) form.requestSubmit(addBtn);
        else form.submit();
      });
    }
  })();
})();
